const doc = [({"ja":({"entryTitle":"友だち募集中！", "entryDescription":"友達追加すると海外旅行相談ができます。"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;